import state from './auth_state'
import cookies from '../../plugins/cookies'

const mutations = {
    SET_TOKEN(state, payload) {
        state.token = payload.token
        state.expiry = payload.expiry
        state.current_user = payload.user

        if (payload.remember) {
            localStorage.setItem('auth', JSON.stringify(state))
        } else {
            cookies.set({
                key: 'auth',
                value: JSON.stringify(state),
                expiry: new Date(payload.expiry)
            })
        }
    },
    CLEAR(vuex_state) {
        const new_default = state()
        Object.assign(vuex_state, new_default)
        localStorage.removeItem('auth')
        cookies.delete('auth')
    },
    SET_PREVENT_REDIRECT(state, preventRedirect) {
        state.preventRedirect = preventRedirect
    },
    SET_EDITION(state, edition) {
        state.edition = edition
    }
}

export default mutations
